import { render, staticRenderFns } from "./peservationInfo.vue?vue&type=template&id=1f55700e&scoped=true"
import script from "./peservationInfo.vue?vue&type=script&lang=js"
export * from "./peservationInfo.vue?vue&type=script&lang=js"
import style0 from "./peservationInfo.vue?vue&type=style&index=0&id=1f55700e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f55700e",
  null
  
)

export default component.exports